import React from 'react';
import { createPortal } from 'react-dom';
import NavigationPrompt from 'react-router-navigation-prompt';

const NavigationBlocker = (props) => {
    const { when, prompt } = props;
    return <NavigationPrompt when={when}>
        {({ onConfirm, onCancel }) => createPortal(
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10000,
            }}>
                <div style={{
                    background: '#fff',
                    borderRadius: '10px',
                    width: '90%',
                    maxWidth: '450px',
                    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                    overflow: 'hidden',
                }}>
                    <div style={{
                        padding: '24px',
                        fontFamily: 'Montserrat, sans-serif',
                        fontSize: '15px',
                        color: '#1a2b3d',
                        lineHeight: '1.6',
                    }}>
                        {prompt ? prompt : 'You have unsaved changes. Are you sure you want to leave?'}
                    </div>
                    <div style={{
                        padding: '12px 24px',
                        borderTop: '1px solid #e8e8e8',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: '10px',
                    }}>
                        <button
                            onClick={onCancel}
                            style={{
                                fontFamily: 'Montserrat, sans-serif',
                                padding: '8px 20px',
                                border: '1px solid #e0e0e0',
                                borderRadius: '6px',
                                background: '#fff',
                                color: '#333',
                                cursor: 'pointer',
                                fontSize: '14px',
                            }}
                        >
                            No
                        </button>
                        <button
                            onClick={onConfirm}
                            style={{
                                fontFamily: 'Montserrat, sans-serif',
                                padding: '8px 20px',
                                border: 'none',
                                borderRadius: '6px',
                                background: '#0784a7',
                                color: '#fff',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: 600,
                            }}
                        >
                            Yes
                        </button>
                    </div>
                </div>
            </div>,
            document.body
        )}
    </NavigationPrompt>;
};

export default NavigationBlocker;
